import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ANIM_BRUSH_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';

export const config = {
    id: ActionType.ANIM_BRUSH,
    content: i18n.t('动画刷'),
    tipMsg: i18n.t('复制所选对象的动画，应用到其他对象上。双击可将对象复制到多个对象上。'),
    icon: ANIM_BRUSH_ICON,
    twdConfig: {
        action: TDWActionType.ANIM_BRUSH,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        text: config.content,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
    },
];
